module.exports = __webpack_public_path__ + "static/media/arrow-from-left.37d0256b.svg";